import React from "react";
import { useParams } from "react-router-dom";
import MyLoader from "../../../src/components/MyLoader";
import FilterProducts from "./filterProducts";
import { useScrollPagination } from "./hooks/useScrollPagination";
import { LoadingSpinner } from "./components/LoadingSpinner";
import ShopSidebar from "./components/shopSidebar";
import { useFiltredProducts } from "./hooks/useProductData";

export default function ShopPage() {
  const { categoryId, categoryName, searchQuery } =
    useParams<{
      categoryId?: string;
      categoryName?: string;
      searchQuery?: string;
    }>();

  const {
    filteredProducts,
    isLoading,
    error,
    isFetchingNextPage,
    fetchNextPage,
  } = useFiltredProducts({ categoryId });

  // Scroll to top on mount
  React.useEffect(() => {
    window.scrollTo(0, 25);
  }, []);

  // Handle infinite scroll
  useScrollPagination({
    fetchNextPage,
    isFetchingNextPage,
  });
  if (error) {
    return (
      <div>
        Error loading products. Please try again later.
      </div>
    );
  }

  if (isLoading || !filteredProducts) {
    return (
      <div className="h-screen w-screen flex justify-center items-center">
        <MyLoader />
      </div>
    );
  }

  return (
    <div className=" flex flex-col font-montserrat w-full gap-5 sm:mt-24 mt-16 h-full">
      <FilterProducts
        allProducts={filteredProducts}
        categoryId={categoryId || ""}
        searchQuery={searchQuery || ""}
      />
      <ShopSidebar
        allProducts={filteredProducts}
        categoryId={categoryId || ""}
        categoryName={categoryName || ""}
        searchQuery={searchQuery || ""}
      />
      {isFetchingNextPage && <LoadingSpinner />}
    </div>
  );
}
